export default __webpack_public_path__ + "static/media/Aller_Bd.e8739fd7.ttf";